import axios from "axios";
import {ajaxCall} from "./ServerFunctions";

export const fetchImage =  async (imageId) => {
    const payload = {
        id: imageId
    };

    // const result = await ajaxCall({action: "images_get", payload})
    // if (result) {
    //     return result;
    // }

    try {
        const {data} = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/image/${imageId}.json`
        );

        return data;
    } catch (e) {

    }
    return [];
}
